import { createFileRoute } from '@tanstack/react-router'
import { signAgreementsSearchSchema } from '@/features/agreements/sign-agreements/model/signAgreementsSearch'
import { SignAgreementsPage } from '@/pages/agreements/ui/SignAgreementsPage'

export const Route = createFileRoute('/agreements_/sign')({
  validateSearch: signAgreementsSearchSchema,
  component: SignAgreementsPage,
})
